/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { LocationModel } from '@kanzi-apes/kanzi-models';
import { fabric } from 'fabric';
import { FloormapUiService } from '../../services/floormap-ui.service';
import * as ShapeMaker from '../../shapes/shape.maker';
import * as ShapesLibrary from '../../shapes/shapes.library';

const { Line, Point } = fabric;
const HORIZONTAL = 'HORIZONTAL';
const VERTICAL = 'VERTICAL';
const OFFSET = ShapeMaker.RL_ROOM_INNER_SPACING / 2;

const Left = (wall: any) => (wall.x1 < wall.x2 ? wall.x1 : wall.x2);
const Top = (wall: any) => (wall.y1 < wall.y2 ? wall.y1 : wall.y2);
const Right = (wall: any) => (wall.x1 > wall.x2 ? wall.x1 : wall.x2);
const Bottom = (wall: any) => (wall.y1 > wall.y2 ? wall.y1 : wall.y2);
@Component({
    selector: 'kanzi-apes-floormap-content-editor',
    templateUrl: './floormap-content-editor.component.html',
    styleUrls: ['./floormap-content-editor.component.scss'],
    standalone: false
})
export class FloormapContentEditorComponent
  implements OnInit, OnChanges, AfterViewInit
{
  @Input() floorDataComplete:{
    dataGroup: { object: any; type: string }[];
    locationSelected: LocationModel | null;
  } | null = null
  // @Input() dataGroup: MapObjectModel[] = [];
  // @Input() floorData: {
  //   room_name: string;
  //   room_extras?: {
  //     type: string;
  //     title: string;
  //     x_position?: number;
  //     y_position?: number;
  //     width?: number;
  //     height?: number;
  //   }[];
  // } | null = null;
  @Output() dataFloorExtrasSave = new EventEmitter<any>();
  @Output() dataFloorLocationsSave = new EventEmitter<any>();
  @Output() dataFloorExtrasDelete = new EventEmitter<any>();
  view!: fabric.Canvas;
  room!: fabric.Group;
  roomLayer!: fabric.Group | fabric.Rect;
  corners: any = [];
  walls: fabric.Line[] = [];
  lastObjectDefinition = null;
  lastObject = null;

  CTRL_KEY_DOWN = false;
  MOVE_WALL_ID = -1;
  ROOM_SIZE = { width: 960, height: 480 };
  DEFAULT_CHAIR = null;
  REMOVE_DW = false;
  constructor(private floormapUIService: FloormapUiService) {}
 

  ngOnInit(): void {
    this.floormapUIService.updateLayout.next(false);
    this.floormapUIService.insertObject.subscribe((dataObj) => {
      this.handleObjectInsertion(dataObj);
      this.saveState();
    });

    this.floormapUIService.saveLayout.subscribe((action) => {
      if (action === 'SAVE') {
        this.onSaveLayout();
      }
    });
    this.floormapUIService.performOperation.subscribe((operation) => {
      switch (operation) {
        case 'ZOOM':
          this.setZoom();
          break;

        case 'DELETE':
          this.deleteItemSelected();
          break;
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if(this.floorDataComplete){
      this.view.clear()
      const {dataGroup, locationSelected} = this.floorDataComplete
      const floorData = locationSelected && locationSelected.params
      ? locationSelected.params.data_floor
      ? locationSelected.params.data_floor
      : null
      : null;
      
      if (dataGroup && dataGroup.length) {
        dataGroup.forEach((group) => {
          this.handleObjectInsertion(group);
        });
      } 
      
      if (floorData) {
        if (floorData.room_name) {
          const rooms = ShapesLibrary.ROOMS.filter(
            (room) => room.title === floorData!.room_name
          );
          this.handleObjectInsertion({ type: 'ROOM', object: rooms[0] });
        }
        if (floorData.room_extras) {
          floorData.room_extras.forEach((extra:any) => {
            let itemExtra:any;
            switch (extra.type) {
              case 'MISCELLANEOUS':
                itemExtra = ShapesLibrary.MISCELLANEOUS.filter(
                  (misc) => misc.title === extra.title
                )[0];
                break;
              case 'DOOR':
                itemExtra = ShapesLibrary.DOORS.filter(
                  (door) => door.title === extra.title
                )[0];
                break;

              case 'WINDOW':
                itemExtra = ShapesLibrary.WINDOWS.filter(
                  (window) => window.title === extra.title
                )[0];
                break;

              default:
                break;
            }
            if (itemExtra) {
              // let obj = {
              //   ...itemExtra,
              //   top: extra.y_position,
              //   left: extra.x_position,
              //   width: extra.width ? extra.width : itemExtra!.width,
              //   height: extra.height ? extra.height : itemExtra!.height,
              // };

              // if(extra && extra.angle){
              //   obj = {
              //     ...obj,
              //     angle:extra.angle
              //   }
              // }

              this.handleObjectInsertion({
                type: extra.type,
                object: {
                  ...itemExtra,
                  top: extra.y_position,
                  left: extra.x_position,
                  width: extra.width ? extra.width : itemExtra!.width,
                  height: extra.height ? extra.height : itemExtra!.height,
                  angle:extra?.angle ? extra.angle:0
                }
              });
            }
          });
        }
      }
      
    }


  }

  ngAfterViewInit() {
    this.setCanvasView();
  }

  get room_origin() {
    return ShapeMaker.RL_ROOM_OUTER_SPACING + ShapeMaker.RL_ROOM_INNER_SPACING;
  }

  handleObjectInsertion({ type, object }: any) {
    console.log("🚀 ~ object insertion:", object)
    if (type === 'ROOM') {
      this.setRoom(object);
      return;
    }
    const group = ShapeMaker.createFurniture(type, object);
    console.log("🚀 ~ group:", group)
    if (type === 'MISCELLANEOUS') {
      group.hasControls = true;
      group.lockScalingX = false;
      group.lockScalingY = false;
      this.saveState();
      group.on('scaling', () => {console.log('scaling')});
    }
    if (type === 'DOOR' || type === 'WINDOW') {
      group.originX = 'center';
      group.originY = 'top';
      group.hasControls = true;
      this.saveState();

      const dws = this.filterObjects(['DOOR', 'WINDOW']);
      console.log("🚀 ~ dws:", dws)
      const dw = dws.length ? dws[dws.length - 1] : null;
      console.log("🚀 ~ dw:", dw)

      let wall, x, y;
      if (!group.top && !group.left && !dw) {
        wall = this.walls[0];
        x = Left(wall) + ShapeMaker.RL_AISLEGAP;
        y = Top(wall);
      } else if (!group.top && !group.left) {
        const od = dw!.angle! % 180 === 0 ? HORIZONTAL : VERTICAL;
        console.log("🚀 ~ od:", od)

        let placeOnNextWall = false;
        wall = this.wallOfDW(dw!);
        if (!wall) {
          wall = this.walls[0];
          x = Left(wall) + ShapeMaker.RL_AISLEGAP;
          y = Top(wall);
        } else {
          if (od === HORIZONTAL) {
            x = dw!.left! + dw!.width! + ShapeMaker.RL_AISLEGAP;
            y = Top(wall);
            if (x + group.width > Right(wall)) {
              placeOnNextWall = true;
            }
          } else {
            y = dw!.top! + dw!.width! + ShapeMaker.RL_AISLEGAP;
            x = Left(wall);
            if (y + group.width > Bottom(wall)) {
              placeOnNextWall = true;
            }
          }

          if (placeOnNextWall) {
            wall =
              this.walls[
                (Number(wall.name!.split(':')[1]) + 1) % this.walls.length
              ];
            const nd = this.directionOfWall(wall);

            if (nd === HORIZONTAL) {
              (x = Left(wall) + ShapeMaker.RL_AISLEGAP), (y = Top(wall));
            } else {
              (x = Left(wall)), (y = Top(wall) + ShapeMaker.RL_AISLEGAP);
            }
          }
        }
      }

      if (!group.top && !group.left) {
        this.locateDW(group, wall as any, x, y);
      }
      group.hasBorders = false;
      this.view.add(group);

      return;
    }

    // // retrieve spacing from object, use rlAisleGap if not specified
    // const newLR = object.lrSpacing || ShapeMaker.RL_AISLEGAP;
    // const newTB = object.tbSpacing || ShapeMaker.RL_AISLEGAP;

    // // object groups use center as origin, so add half width and height of their reported
    // // width and size; note that this will not account for chairs around tables, which is
    // // intentional; they go in the specified gaps
    // group.left = newLR + group.width / 2 + this.room_origin;
    // group.top = newTB + group.height / 2 + this.room_origin;

    // if (this.lastObject) {
    //   // retrieve spacing from object, use rlAisleGap if not specified
    //   const lastLR =
    //     this.lastObjectDefinition.lrSpacing || ShapeMaker.RL_AISLEGAP;
    //   const lastTB =
    //     this.lastObjectDefinition.tbSpacing || ShapeMaker.RL_AISLEGAP;

    //   // calculate maximum gap required by last and this object
    //   // Note: this isn't smart enough to get new row gap right when
    //   // object above had a much bigger gap, etc. We aren't fitting yet.
    //   const useLR = Math.max(newLR, lastLR),
    //     useTB = Math.max(newTB, lastTB);

    //   // using left/top vocab, though all objects are now centered
    //   const lastWidth = this.lastObjectDefinition.width || 100;
    //   const lastHeight = this.lastObjectDefinition.height || 40;

    //   let newLeft = this.lastObject.left + lastWidth + useLR;
    //   let newTop = this.lastObject.top;

    //   // make sure we fit left to right, including our required right spacing
    //   if (newLeft + group.width + newLR > this.ROOM_SIZE.width) {
    //     newLeft = newLR + group.width / 2;
    //     newTop += lastHeight + useTB;
    //   }

    //   group.left = newLeft;
    //   group.top = newTop;

    //   if (group.left - group.width / 2 < this.room_origin) {
    //     group.left += this.room_origin;
    //   }
    //   if (group.top - group.height / 2 < this.room_origin) {
    //     group.top += this.room_origin;
    //   }
    // }

    this.view.add(group);
    this.view.setActiveObject(group);

    this.lastObject = group;
    this.lastObjectDefinition = object;
  }

  setCanvasView() {
    const canvas = new fabric.Canvas('floor-main-editor');
    canvas.setWidth(ShapeMaker.RL_VIEW_WIDTH * ShapeMaker.RL_FOOT);
    canvas.setHeight(ShapeMaker.RL_VIEW_HEIGHT * ShapeMaker.RL_FOOT);
    this.view = canvas;

    const cornersOfWall = (obj: fabric.Line) => {
      const id = Number(obj.name?.split(':')[1]);
      const v1Id = id;
      const v1 = this.corners[v1Id];
      const v2Id = (id + 1) % this.walls.length;
      const v2 = this.corners[v2Id];
      return { v1, v1Id, v2, v2Id };
    };

    this.view.on('selection:created', (e: fabric.IEvent) => {
      console.log("🚀 CREATED:", e)
      if (this.floormapUIService.roomEdit) {
        return;
      }
      this.onSelected();
    });

    this.view.on('selection:updated', (e: fabric.IEvent) => {
      console.log("🚀UPDATE:", e)
      if (this.floormapUIService.roomEdit) {
        return;
      }
      this.onSelected();
    });

    this.view.on('selection:cleared', (e: fabric.IEvent) => {
      if (this.floormapUIService.roomEdit) {
        return;
      }
      this.floormapUIService.selections = [];
      this.floormapUIService.ungroupable = false;
    });

    this.view.on('object:modified', (item) => {
      const action = item.action;
      if(action === 'drag'){
        if (this.MOVE_WALL_ID !== -1) {
          this.MOVE_WALL_ID = -1;
        }
        this.onMovedItem(item.target!);
        this.saveState();
      }else if(action==='rotate'){
        this.onMovedItem(item.target!);
        this.saveState()
      }

    });

    // this.view.on('object:moved', (item) => {
    //   if (this.MOVE_WALL_ID !== -1) {
    //     this.MOVE_WALL_ID = -1;
    //   }
    //   this.onMovedItem(item.target!);
    //   this.saveState();
    // });

    // this.view.on('object:rotated', () => this.saveState());

    this.view.on('mouse:down:before', (e: fabric.IEvent) => {
      const obj = e.target;

      if (
        this.floormapUIService.roomEdit &&
        obj &&
        obj.name!.indexOf('WALL') > -1 &&
        obj instanceof Line
      ) {
        const { v1, v2, v1Id }: any = cornersOfWall(obj);
        let { v2Id }: any = cornersOfWall(obj);
        const v0Id = v1Id === 0 ? this.corners.length - 1 : v1Id - 1;
        const v3Id = v2Id === this.corners.length - 1 ? 0 : v2Id + 1;
        const v0: any = this.corners[v0Id];
        const v3: any = this.corners[v3Id];

        this.MOVE_WALL_ID = v1Id;

        if (
          (v0.top === v1.top && v1.top === v2.top) ||
          (v0.left === v1.left && v1.left === v2.left)
        ) {
          this.corners.splice(
            v1Id,
            0,
            this.drawCorner(new Point(v1.left, v1.top))
          );
          this.MOVE_WALL_ID = v1Id + 1;
          v2Id += 1;
        }

        if (
          (v1.top === v2.top && v2.top === v3.top) ||
          (v1.left === v2.left && v2.left === v3.left)
        ) {
          this.corners.splice(
            v2Id + 1,
            0,
            this.drawCorner(new Point(v2.left, v2.top))
          );
        }

        this.drawRoom();
        this.saveState();
      }
    });
  }

  onMovedItem(item: fabric.Object) {
    this.floormapUIService.updateLayout.next(true);
    const nameItem = item.name!.split(':')[0];
    if (
      nameItem === 'MISCELLANEOUS' ||
      nameItem === 'DOOR' ||
      nameItem === 'WINDOW'
    ) {
      this.floormapUIService.updatedFloor.push(item);
    } else {
      this.floormapUIService.updatedFloorLocations.push(item);
    }
  }

  onSelected() {
    const active = this.view.getActiveObject();
    if (active?.name?.split(':')[0] !== 'MISCELLANEOUS') {
      (active!.lockScalingX = true), (active!.lockScalingY = true);
    }
    if (!active?.name) {
      active!.name = 'GROUP';
    }
    this.floormapUIService.selections = this.view.getActiveObjects();
    this.setGroupableState();
  }

  onSaveLayout() {
    console.log("🚀 ~ SAVE LAYOUT METODO", this.floormapUIService.updatedFloor)
    const floorData = this.floormapUIService.updatedFloor.map((item) => {
      return {
        type: item.name.split(':')[0],
        title: item.name.split(':')[1],
        width: item.width,
        height: item.height,
        x_position: item.left,
        y_position: item.top,
        angle:item.angle
      };
    });
    const floorDataLocations = this.floormapUIService.updatedFloorLocations.map(
      (item) => {
        return {
          type: item.name.split(':')[0],
          title: item.name.split(':')[1],
          locationName: item.name.split(':')[2],
          x_position: item.left,
          y_position: item.top,
        };
      }
    );
    const floorDataExtraDelete = this.floormapUIService.deletedFloor.map(
      (item) => {
        return {
          type: item.name.split(':')[0],
          title: item.name.split(':')[1],
        };
      }
    );

    if (floorData && floorData.length > 0) {
      this.floormapUIService.updatedFloor = [];
      this.dataFloorExtrasSave.emit(floorData);
    }
    if (floorDataLocations && floorDataLocations.length > 0) {
      this.floormapUIService.updatedFloorLocations = [];
      this.dataFloorLocationsSave.emit(floorDataLocations);
    }
    if (floorDataExtraDelete && floorDataExtraDelete.length > 0) {
      this.floormapUIService.deletedFloor = [];
      this.dataFloorExtrasDelete.emit(floorDataExtraDelete);
    }
  }

  setGroupableState() {
    if (this.floormapUIService.selections.length > 1) {
      this.floormapUIService.ungroupable = false;
      return;
    }

    const obj = this.view.getActiveObject();
    const type = obj!.name ? obj!.name.split(':')[0] : '';

    if (ShapeMaker.RL_UNGROUPABLES.indexOf(type) > -1) {
      this.floormapUIService.ungroupable = false;
    } else {
      this.floormapUIService.ungroupable = true;
    }
  }

  saveState() {
    const state = this.view.toDatalessJSON([
      'name',
      'hasControls',
      'selectable',
      'hasBorders',
      'evented',
      'hoverCursor',
      'moveCursor',
    ]);
    this.floormapUIService.saveState.next(JSON.stringify(state));
  }

  drawCorner(p: fabric.Point) {
    const c = new fabric.Rect({
      left: p.x,
      top: p.y,
      strokeWidth: 0,
      hasControls: false,
      originX: 'center',
      originY: 'center',
      name: 'CORNER',
    });
    this.setCornerStyle(c);
    return c;
  }

  setCornerStyle(c: fabric.Rect) {
    c.moveCursor = this.view.freeDrawingCursor;
    c.hoverCursor = this.view.freeDrawingCursor;
    c.selectable = false;
    c.evented = false;
    c.width = c.height =
      (ShapeMaker.RL_ROOM_INNER_SPACING /
        (this.floormapUIService.roomEdit ? 1.5 : 2)) *
      2;
    c.set(
      'fill',
      this.floormapUIService.roomEdit
        ? ShapeMaker.RL_CORNER_FILL
        : ShapeMaker.RL_ROOM_STROKE
    );
  }

  setRoom({ width, height }: any) {
    if (this.walls.length) {
      this.view.remove(...this.walls);
      this.view.renderAll();
    }

    const LT = new Point(
      ShapeMaker.RL_ROOM_OUTER_SPACING,
      ShapeMaker.RL_ROOM_OUTER_SPACING
    );
    const RT = new Point(LT.x + width, LT.y);
    const LB = new Point(LT.x, LT.y + height);
    const RB = new Point(RT.x, LB.y);

    this.corners = [LT, RT, RB, LB].map((p) => this.drawCorner(p));
    this.drawRoom();
  }

  drawRoom() {
    const exists = this.view
      .getObjects()
      .filter((obj) => obj.name!.indexOf('WALL') > -1 || obj.name === 'CORNER');
    this.view.remove(...exists);
    this.view.add(...this.corners);

    const wall = (coords: number[], index: number) =>
      new Line(coords, {
        stroke: ShapeMaker.RL_ROOM_STROKE,
        strokeWidth: ShapeMaker.RL_ROOM_INNER_SPACING,
        name: `WALL:${index}`,
        originX: 'center',
        originY: 'center',
        hoverCursor: this.floormapUIService.roomEdit
          ? this.view.moveCursor
          : this.view.defaultCursor,
        hasControls: false,
        hasBorders: false,
        selectable: this.floormapUIService.roomEdit,
        evented: this.floormapUIService.roomEdit,
        cornerStyle: 'rect',
      });
    let LT = new Point(9999, 9999),
      RB = new Point(0, 0);

    this.walls = this.corners.map((corner: any, i: any) => {
      const start = corner;
      const end =
        i === this.corners.length - 1 ? this.corners[0] : this.corners[i + 1];

      if (corner.top < LT.x && corner.left < LT.y) {
        LT = new Point(corner.left, corner.top);
      }
      if (corner.top > RB.y && corner.left > RB.y) {
        RB = new Point(corner.left, corner.top);
      }

      const w = wall([start.left, start.top, end.left, end.top], i);
      return w;
    });

    this.view.add(...this.walls);
    this.walls.forEach((w) => w.sendToBack());
    this.ROOM_SIZE = { width: RB.x - LT.x, height: RB.y - LT.y };
  }

  filterObjects(names: string[]) {
    return this.view
      .getObjects()
      .filter((obj) => names.some((n) => obj.name!.indexOf(n) > -1));
  }

  wallOfDW(dw: fabric.Group | fabric.Object) {
    const d = dw.angle! % 180 === 0 ? HORIZONTAL : VERTICAL;
    return this.walls.find(
      (w) =>
        Math.abs(d === HORIZONTAL ? w.top! - dw.top! : w.left! - dw.left!) ===
        OFFSET
    );
  }

  directionOfWall(wall: fabric.Line) {
    if (wall.x1 === wall.x2) {
      return VERTICAL;
    } else {
      return HORIZONTAL;
    }
  }

  locateDW(dw: fabric.Group, wall: fabric.Line, x: number, y: number) {
    const dWall = this.directionOfWall(wall);
    console.log("🚀 ~ dWall:", dWall)
    const dDW = dw.angle! % 180 === 0 ? HORIZONTAL : VERTICAL;
    if (dWall !== dDW) {
      dw.angle = (dw.angle! + 90) % 360;
    }
    (dw.top = y), (dw.left = x);
    const center = dw.getCenterPoint();
    if (dWall === HORIZONTAL) {
      center.y < dw.top ? (dw.top += OFFSET) : (dw.top -= OFFSET);
    } else {
      center.x < dw.left ? (dw.left += OFFSET) : (dw.left -= OFFSET);
    }
    return dw;
  }

  setZoom() {
    const actualZoom = this.view.getZoom();
    const newZoom = this.floormapUIService.zoom / 100;
    const actualHeight = this.view.getHeight();
    const actualWidth = this.view.getWidth();
    if (actualZoom < newZoom) {
      this.view.setZoom(newZoom);
      if (actualZoom >= 1) {
        this.view.setHeight(actualHeight * newZoom);
        this.view.setWidth(actualWidth * newZoom);
      } else {
        this.view.setWidth(ShapeMaker.RL_VIEW_WIDTH * ShapeMaker.RL_FOOT);
        this.view.setHeight(ShapeMaker.RL_VIEW_HEIGHT * ShapeMaker.RL_FOOT);
      }
    } else if (actualZoom > newZoom) {
      this.view.setZoom(newZoom);
      if (actualZoom >= 1) {
        this.view.setHeight(actualHeight / actualZoom);
        this.view.setWidth(actualWidth / actualZoom);
      } else {
        this.view.setWidth(ShapeMaker.RL_VIEW_WIDTH * ShapeMaker.RL_FOOT);
        this.view.setHeight(ShapeMaker.RL_VIEW_HEIGHT * ShapeMaker.RL_FOOT);
      }
    }
    this.view.renderAll();
  }

  deleteItemSelected() {
    if (this.floormapUIService.roomEdit) {
      return;
    }
    this.floormapUIService.selections.forEach((selection) => {
      const itemType = selection.name.split(':')[0];
      if (itemType === 'FURNITURE') {
        this.floormapUIService.sendErrorMsg(
          `Los muebles de locaciones no se permiten elminar.`
        );
      } else {
        this.floormapUIService.updateLayout.next(true);
        this.floormapUIService.deletedFloor.push(selection);
        this.view.remove(selection);
        this.view.discardActiveObject();
        this.view.requestRenderAll();
        this.saveState();
      }
    });
  }
}
